import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { selectCommandExecutionError, selectCommandExecutionErrorId, selectPinSetting, selectShowPinPad, selectValidToken } from 'src/app/store/permissions/permissions.selector';

@Component({
	selector: 'app-pin-pad',
	templateUrl: './pin-pad.component.html',
	styles: [
		`
		.custom-otp-input {
			width: 45px;
			font-family: 'Roboto';
			font-weight: 400;
			font-size: 36px;
			border: 0 none;
			appearance: none;
			text-align: center;
			transition: all 0.2s;
			background: transparent;
			border-bottom: 2px solid var(--blue-400);
			border-radius: 0px;
			margin: 0 0.2rem;
		}

		.custom-otp-input:focus {
			outline: 0 none;
			box-shadow: none;
			border-bottom-color: var(--primary-color);
		}

		img {
			user-select: none;
			-webkit-user-drag: none;
			user-drag: none;
		}
		`
	],
})
export class PinPadComponent implements OnInit, OnDestroy {
	@Output() pinConfirmed = new EventEmitter<number[]>();

	showPinPad$: Observable<boolean | undefined>;
	showPinPadSub: Subscription | undefined;
	commandExecutionError$: Observable<string | undefined>;
	commandExecutionErrorSub: Subscription | undefined;
	commandExecutionErrorId$: Observable<number | undefined>;
	commandExecutionErrorIdSub: Subscription | undefined;


	pinLength = 5;
	display: string[] = ['', '', '', '', ''];

	pin: number[] = [];

	pinpadBtns: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9];

	showPinPad: boolean;

	visibleMode = false;

	commandExecutionError: string;

	commandExecutionErrorId: number;

	errorMessage: number;
	errorMessageSub: Subscription;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	COLUMN_TITLE_MIN_WD = 647;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_MX7 = 1700;
	LG_WIDTH = 1500;

	MAX_MD_WIDTH_SHORT = 858;

	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.showPinPad$ = this.store.select(selectShowPinPad);
		this.commandExecutionError$ = this.store.select(selectCommandExecutionError);
		this.commandExecutionErrorId$ = this.store.select(selectCommandExecutionErrorId);
	}

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
		if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(event.key)) {
			this.onKeyPressed(Number(event.key));
		}
	}

	@HostListener('document:keydown', ['$event'])
	handleKeyPressEvent(event: KeyboardEvent): void {
		if (event.key === 'Backspace') {
			this.pin = this.pin.slice(0, -1);
			this.redrawDisplay();
		} else if ((event.key === 'Enter') && (this.pin.length === this.pinLength)) {
			this.onOkPressed();
		}
	}

	ngOnInit(): void {
		this.showPinPadSub = this.showPinPad$.subscribe(show => {
			this.showPinPad = show;
		});
		this.commandExecutionErrorSub = this.commandExecutionError$.subscribe(commandExecutionError => {
			this.commandExecutionError = commandExecutionError;
		});
		this.commandExecutionErrorIdSub = this.commandExecutionErrorId$.subscribe(commandExecutionErrorId => {
			if (commandExecutionErrorId === null) {
				this.commandExecutionErrorId = 0;
			} else {
				this.commandExecutionErrorId = commandExecutionErrorId;
			}
			if (commandExecutionErrorId === null || commandExecutionErrorId === undefined) {
				this.errorMessage = 1; // blue
			}
			else if (commandExecutionErrorId === 0) {
				this.errorMessage = 0; // verde
			} else {
				this.errorMessage = 2; // red
			}
		});

		this.onResize();
	}

	ngOnDestroy(): void {
		this.showPinPadSub?.unsubscribe();
		this.errorMessageSub?.unsubscribe();
	}

	onKeyPressed(num: number) {
		this.errorMessage = 1;

		if (this.pin.length === this.pinLength) {
			return;
		}
		this.pin = this.pin.concat(num);
		this.redrawDisplay();
	}

	redrawDisplay() {
		const newDisplay = ['', '', '', '', ''];
		for (let i = 0; i < this.pinLength; i++) {
			this.drawDigit(newDisplay, this.pin[i], i);
		}
		this.display = newDisplay;
	}

	drawDigit(display: string[], digit: number, position: number): void {
		if (digit === undefined) {
			return;
		}
		if (this.visibleMode) {
			display[position] = digit.toString();
		} else {
			display[position] = '\u2022';
		}
	}

	onClearPressed() {
		this.pin = [];
		this.redrawDisplay();
	}

	onOkPressed() {
		this.pinConfirmed.emit(this.pin);
		this.pin = [];
		this.redrawDisplay();
	}

	toggleVisibility(): void {
		this.visibleMode = !this.visibleMode;
		this.redrawDisplay();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return (this.screenWidth < this.MIN_MD_WIDTH);
	}
}
